import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function SponsorshipPage() {
  return (
    <main>
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-32 pb-20 bg-forest-800 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/activities.jpeg"
            alt="協賛"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-forest-800/60 to-forest-800/90" />
        </div>
        <div className="absolute right-10 top-1/2 -translate-y-1/2 pointer-events-none opacity-10 hidden lg:block">
          <div className="relative w-48 h-48">
            <div className="absolute inset-0 rounded-full border-2 border-cream-200" />
            <div className="absolute inset-5 rounded-full border border-cream-200" />
            <div className="absolute inset-10 rounded-full border border-cream-200" />
            <div className="absolute inset-16 rounded-full border border-cream-200" />
          </div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-cream-400/50" />
            <span className="text-cream-400/60 text-xs font-serif tracking-widest2">SPONSORSHIP</span>
          </div>
          <h1 className="text-cream-100 font-serif font-light text-4xl md:text-5xl tracking-wider">
            協賛
          </h1>
        </div>
      </section>

      {/* Content */}
      <section className="bg-cream-100 py-20 md:py-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block border border-forest-600/30 px-6 py-1.5 mb-5">
              <span className="text-forest-600 text-xs font-serif tracking-widest2">SPONSORSHIP</span>
            </div>
            <h2 className="text-forest-800 font-serif font-light text-3xl tracking-wider">協賛について</h2>
          </div>

          <div className="bg-white border border-cream-300 p-10 md:p-14 text-center">
            <div className="w-16 h-16 flex items-center justify-center border border-cream-300 mx-auto mb-6">
              <i className="ri-time-line text-forest-500/40 text-2xl" />
            </div>
            <p className="text-forest-500/70 text-sm font-serif tracking-widest mb-4">準備中</p>
            <p className="text-forest-400/50 text-xs font-serif leading-relaxed mb-8">
              協賛に関する情報は後日掲載いたします。<br />しばらくお待ちください。
            </p>
            <div className="border-t border-cream-200 pt-8">
              <p className="text-forest-600/70 text-sm font-serif tracking-wider mb-3">
                協賛に関するお問い合わせ
              </p>
              <a
                href="mailto:omfes.info@gmail.com"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-forest-700 text-cream-200 text-sm font-serif tracking-widest hover:bg-forest-600 transition-colors duration-200 rounded-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line" />
                omfes.info@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
